import React, { useRef } from "react";
// import PropTypes from "prop-types";
import styles from "./styles/InvoicePage.module.css";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDetailOrderAction } from "@redux/actions";
import clsx from "clsx";
import logo from "@assets/svgs/logo_white.svg";
import { ADMIN_ROLE } from "@constants";
import { listCountries } from "@pages";
import { TableCustom } from "@components/TableCustom/TableCustom";
import { Button } from "react-bootstrap";
import { useReactToPrint } from "react-to-print";
import moment from "moment";

const InvoicePage = () => {
  // state
  const { detailOrder } = useSelector((state) => state.orders);
  const { login } = useSelector((state) => state.auth);
  const { profile } = useSelector((state) => state.user);

  // variables
  const columns = [
    {
      title: "Item",
      dataIndex: "course",
      render: (course) => {
        return <span>{`${course.title}`}</span>;
      },
    },
    {
      title: "Price",
      dataIndex: "course",
      render: (course) => {
        return <span>{`$${course.price}`}</span>;
      },
    },
    {
      title: "Discount",
      dataIndex: "course",
      render: (course) => {
        return <span>{`$${course.priceDiscount.toFixed(2)}`}</span>;
      },
    },
    {
      title: "Total Amount",
      dataIndex: "course",
      render: (course) => {
        return (
          <span>{`$${(course.price - course.priceDiscount).toFixed(2)}`}</span>
        );
      },
    },
  ];

  // logics before hooks

  // hooks
  const params = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    copyStyles: true,
  });

  // logics

  const getDiscountValidWithTime = (discounts, time) => {
    let totalPercent = 0;
    discounts.map((value) => {
      if (
        moment(time) >= moment(value.startDate) &&
        moment(time) <= moment(value.endDate)
      ) {
        totalPercent += value.discountPercent;
      }
    });
    return totalPercent / 100;
  };

  // UI partials

  // effects
  if (
    profile.data &&
    detailOrder.data &&
    profile.data.id !== detailOrder.data.user.id
  ) {
    navigate("/404");
  }

  useEffect(() => {
    dispatch(getDetailOrderAction(params.id));
  }, [params.id]);

  // render
  return (
    <div ref={componentRef} className={clsx(styles.container)}>
      <div className={clsx(styles.headerContainer)}>
        <Link to={login.role === ADMIN_ROLE ? "/admin" : "/"}>
          <img src={logo} alt="logo" height={32} width={135} />
        </Link>
        <div>
          <span>Invoice</span>
        </div>
      </div>
      <div className={clsx(styles.contentContainer)}>
        {detailOrder.data ? (
          <>
            <div className={clsx(styles.contentDetail)}>
              <div className={clsx(styles.orderOwner)}>
                <h2>To</h2>
                <div>{`${detailOrder.data.firstName} ${detailOrder.data.lastName} (${detailOrder.data.user.fullName})`}</div>
                <div>{`${detailOrder.data.address}`}</div>
                <div>{`${detailOrder.data.phoneNumber}`}</div>
                <div>{`${
                  listCountries.filter((value) => {
                    return value.id === detailOrder.data.country;
                  })[0]?.name
                }`}</div>
              </div>
              <div className={clsx(styles.orderOwner)}>
                <h2>Date</h2>
                <div>{`Date: ${moment(detailOrder.data.createdAt)
                  .add(7, "hours")
                  .format("YYYY-MM-DD | HH:mm:ss")}`}</div>
                <div>{`Order ID: ${detailOrder.data.id}`}</div>
              </div>
            </div>
            <TableCustom
              className={clsx(styles.card)}
              columns={columns}
              dataSource={detailOrder.data.orderItem.map((value) => {
                const course = {
                  ...value.course,
                  priceDiscount:
                    value.course.price *
                    getDiscountValidWithTime(
                      value.course.discounts,
                      detailOrder.data.createdAt
                    ),
                };
                // console.log(
                //   getDiscountValidWithTime(
                //     value.course.discounts,
                //     detailOrder.data.createAt
                //   )
                // );
                return {
                  course: course,
                };
              })}
              isLoading={detailOrder.processing}
            />
            <div className={clsx(styles.invoiceTotal)}>
              <span>{`Invoice Total: USD $${detailOrder.data.totalPrice.toFixed(
                2
              )}`}</span>
            </div>
            <div
              style={{ fontSize: "14px", color: "#757575", fontWeight: 400 }}
            >
              <span>Thanks for buying</span>
            </div>
            <div className={clsx(styles.buttonPrint)}>
              <Button onClick={handlePrint}>Print</Button>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

/* required: display name */
InvoicePage.displayName = "InvoicePage";

/* required: props types */
InvoicePage.propTypes = {};

/* required: default props */
InvoicePage.defaultProps = {};

export { InvoicePage };
